{
  "fr": {
    "activerecord": {
      "attributes": {
        "activity": {
          "action": "Action",
          "created_at": "Créée le",
          "data": "Données",
          "happened_at": "S'est passé le",
          "map": "Carte",
          "subject": "Sujet",
          "subject_name": "Nom du sujet",
          "subject_type": "Type",
          "updated_at": "Mise à jour le",
          "user": "Utilisateur",
          "username": "Nom d'utilisateur"
        },
        "comment": {
          "content": "Contenu",
          "created_at": "Créé le",
          "removed_at": "Retiré le",
          "removed_by_map_owner": "Retiré par le propriétaire de la carte",
          "subject": "Sujet",
          "subject_type": "Type de sujet",
          "updated_at": "Modifié le",
          "user": "Auteur"
        },
        "element": {
          "created_at": "Créé le",
          "diameter": "Diamètre actuel",
          "geometry": "Géométrie",
          "implantation_mode": "Mode d'implantation",
          "implantation_note": "Note d'implantation",
          "implantation_planned_for": "Implantation prévue le",
          "implanted_at": "Implanté le",
          "implanted_quantity": "Quantité implantée",
          "layer": "Calque",
          "name": "Nom",
          "note": "Note",
          "observations_count": "Observations",
          "patch": "Parcelle",
          "removal_planned_for": "Enlèvement prévu le",
          "removed_at": "Retiré le",
          "resource": "Ressource",
          "updated_at": "Mis à jour le"
        },
        "element/implantation_mode": {
          "potted_shoot": "Rempotage de pousse",
          "potted_sowing": "Semis en pot",
          "shoot_in_soil": "Pousse en pleine terre",
          "soil_sowing": "Semis en pleine terre"
        },
        "family": {
          "created": "Créée",
          "created_at": "Créé le",
          "kingdom": "Règne",
          "name": "Nom",
          "source": "Source",
          "sync": "Sync",
          "sync_id": "Sync ID",
          "updated": "Mise à jour",
          "updated_at": "Mis à jour le"
        },
        "family/kingdom": {
          "animal": "Animal",
          "plant": "Végétal"
        },
        "genus": {
          "created": "Créé",
          "created_at": "Créé le",
          "family": "Famille",
          "name": "Nom",
          "source": "Source",
          "sync": "Sync",
          "sync_id": "Sync ID",
          "updated": "Mis à jour",
          "updated_at": "Mis à jour le"
        },
        "harvest": {
          "created_at": "Créé le",
          "element": "Élément",
          "harvested_at": "Récolté le",
          "quantity": "Quantité",
          "unit": "Unité",
          "updated_at": "Mis à jour le",
          "user": "Créé par"
        },
        "harvest/unit": {
          "gram": "Gramme",
          "litre": "Litre",
          "piece": "Pièce"
        },
        "jwt_token": {
          "created_at": "Date de création",
          "description": "Description",
          "expires_at": "Date d'expiration",
          "updated_at": "Date de mise à jour",
          "user": "Utilisateur"
        },
        "layer": {
          "created_at": "Créé le",
          "map": "Carte",
          "name": "Nom",
          "position": "Position",
          "updated_at": "Mis à jour le",
          "visible_by_default": "Visible par défaut"
        },
        "link": {
          "approved_by": "Approuvé par",
          "created_at": "Créé le",
          "description": "Description",
          "title": "Titre",
          "updated_at": "Mis à jour le",
          "url": "URL",
          "user": "Proposé par"
        },
        "map": {
          "background_color": "Couleur de fond",
          "center": "Créée le",
          "created_at": "Créé le",
          "extent_height": "Hauteur de l'étendue",
          "extent_width": "Largeur de l'étendue",
          "hide_background": "Masquer l'image de fond",
          "name": "Nom",
          "notes": "Notes",
          "observations_count": "Observations",
          "publicly_available": "Publique",
          "slug": "Slug",
          "updated_at": "Mis à jour le",
          "user": "Propriétaire"
        },
        "notification": {
          "archived_at": "Archivée le",
          "content": "Contenu",
          "created_at": "Créée le",
          "map": "Carte",
          "recipient": "Destinataire",
          "sender": "Envoyeur",
          "subject": "Sujet",
          "subject_type": "Type de sujet",
          "type": "Type",
          "updated_at": "Mise à jour le"
        },
        "observation": {
          "comments_count": "Commentaires",
          "content": "Contenu",
          "created_at": "Créée le",
          "made_at": "Faite le",
          "pictures": "Images",
          "subject": "Sujet",
          "subject_type": "Type de sujet",
          "title": "Titre",
          "updated_at": "Mise à jour le",
          "user": "Utilisateur"
        },
        "patch": {
          "created_at": "Créée le",
          "geometry": "Géométrie",
          "layer": "Calque",
          "map": "Carte",
          "name": "Nom",
          "observations_count": "Observations",
          "updated_at": "Mis à jour le"
        },
        "path": {
          "background_color": "Couleur de fond",
          "created_at": "Créé le",
          "geometry": "Géométrie",
          "layer": "Calque",
          "map": "Carte",
          "name": "Nom",
          "observations_count": "Observations",
          "stroke_color": "Couleur du trait",
          "stroke_style_preset": "Style du trait",
          "stroke_width": "Largeur du trait",
          "updated_at": "Mis à jour le"
        },
        "resource": {
          "child_count": "Dérivés",
          "color": "Couleur",
          "common_names": "Noms communs",
          "created": "Créée",
          "created_at": "Créée le",
          "crop_rotation_group": "Groupe de rotation",
          "description": "Description",
          "diameter": "Diamètre à maturité",
          "generic": "Générique",
          "genus": "Genre",
          "harvesting_months": "Mois de récolte",
          "latin_name": "Nom latin",
          "name": "Nom",
          "parent": "Resource parente",
          "resource_interactions_group": "Groupe d'interactions",
          "sheltered_sowing_months": "Mois de plantation en intérieur",
          "soil_sowing_months": "Mois de plantation en pleine terre",
          "sources": "Sources",
          "sync": "Sync",
          "sync_id": "Sync ID",
          "tag_list": "Tags",
          "updated": "Mise à jour",
          "updated_at": "Mise à jour le"
        },
        "resource/crop_rotation_group": {
          "leaf": "Légume feuille",
          "legume": "Légumineuse",
          "manure": "Engrais vert",
          "root": "Légume racine"
        },
        "resource_interaction": {
          "created": "Créée",
          "created_at": "Créée le",
          "nature": "Nature",
          "notes": "Notes",
          "sources": "Sources",
          "subject": "Groupe ayant un impact",
          "sync": "Sync",
          "target": "Groupe impacté",
          "updated": "Mise à jour",
          "updated_at": "Mise à jour le"
        },
        "resource_interaction/nature": {
          "amensalism": "Amensalisme",
          "commensalism": "Commensalisme",
          "competition": "Compétition",
          "mutualism": "Mutualisme",
          "neutralism": "Neutralisme",
          "parasitism": "Parasitisme",
          "unspecified_negative": "Négative (incomplète)",
          "unspecified_positive": "Positive (incomplète)"
        },
        "resource_interactions_group": {
          "created": "Créé",
          "created_at": "Créé le",
          "description": "Description",
          "name": "Nom",
          "sync": "Sync",
          "updated": "Mis à jour",
          "updated_at": "Mis à jour le"
        },
        "resource_note": {
          "content": "Contenu",
          "created_at": "Créée le",
          "resource": "Ressource",
          "updated_at": "Mise à jour le",
          "user": "Utilisateur",
          "visible": "Visible par la communauté"
        },
        "task": {
          "action": "Action",
          "assignee": "Assignée à",
          "comments_count": "Commentaires",
          "created_at": "Créée le",
          "done_at": "Fait le",
          "name": "Nom",
          "notes": "Notes",
          "planned_for": "Prévu pour le",
          "subject": "Sujet",
          "subject_type": "Type",
          "updated_at": "Mise à jour le"
        },
        "team_mate": {
          "accepted_at": "Acceptée le",
          "created_at": "Créée le",
          "map": "Carte",
          "updated_at": "Mise à jour le",
          "user": "Utilisateur"
        },
        "user": {
          "calendar_token": "Jeton d'accès au calendrier",
          "confirmation_sent_at": "Confirmation envoyée le",
          "confirmation_token": "Jeton de confirmation",
          "confirmed_at": "Confirmé le",
          "created_at": "Créé le",
          "current_password": "Mot de passe actuel",
          "current_sign_in_at": "Date de la connexion actuelle",
          "current_sign_in_ip": "IP de la connexion actuelle",
          "email": "Courriel",
          "encrypted_password": "Mot de passe chiffré",
          "failed_attempts": "Tentatives échouées",
          "invitation_accepted_at": "Invitation acceptée le",
          "invitation_created_at": "Invitation créée le",
          "invitation_limit": "Limite d'invitation",
          "invitation_sent_at": "Invitation envoyée le",
          "invitation_token": "Jeton d'invitation",
          "invitations_count": "Nombre d'invitations",
          "invited_by": "Invité par",
          "invited_by_type": "Type invitant",
          "last_sign_in_at": "Date de la dernière connexion",
          "last_sign_in_ip": "IP de la dernière connexion",
          "locked_at": "Verrouillé à",
          "map": "Carte par défaut",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "preferences": "Préférences",
          "public_profile": "Profil public",
          "remember_created_at": "Ouverture de session le",
          "remember_me": "Se souvenir de moi ?",
          "reset_password_sent_at": "Demande de réinitialisation envoyée le",
          "reset_password_token": "Jeton de réinitialisation",
          "role": "Rôle",
          "sign_in_count": "Nombre des connexions",
          "theme": "Thème",
          "unconfirmed_email": "Courriel à confirmer",
          "unlock_token": "Clé de déverrouillage",
          "updated_at": "Mis à jour le",
          "username": "Nom d'utilisateur"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dim",
        "lun",
        "mar",
        "mer",
        "jeu",
        "ven",
        "sam"
      ],
      "abbr_month_names": [
        "",
        "janv.",
        "févr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "août",
        "sept.",
        "oct.",
        "nov.",
        "déc."
      ],
      "day_names": [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
      ],
      "formats": {
        "date_js": "%-e %b %Y",
        "default": "%d/%m/%Y",
        "long": "%-d %B %Y",
        "short": "%-d %b"
      },
      "month_names": [
        null,
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "generic": {
      "all": "Tout",
      "are_you_sure": "Êtes-vous sûr(e) ?",
      "back": "Retours",
      "cancel": "Annuler",
      "clear": "Vider",
      "comma_separated_values": "Liste d'éléments séparés par des virgules",
      "copy": "Copier",
      "date": "Date",
      "definition": "%{value} : ",
      "destroy": "Détruire",
      "edit": "Modifier",
      "id": "ID",
      "info": "Information",
      "loading": "Chargement",
      "loading_general_data": "Chargement des données de base",
      "missing_configuration_value_html": "Configuration d'instance manquante pour <code>%{key}</code>",
      "new_observation": "Nouvelle observation",
      "new_task": "Nouvelle tâche",
      "no": "Non",
      "nothing_to_display_yet": "Il n'y a rien à afficher... pour le moment",
      "ok": "OK",
      "patch": {
        "name": "Une parcelle"
      },
      "remove": "Enlever",
      "save": "Enregistrer",
      "search": "Rechercher",
      "show": "Afficher",
      "time_ago": "il y a %{string}",
      "with": "Avec",
      "without": "Sans",
      "yes": "Oui"
    },
    "js": {
      "activities": {
        "element": {
          "change_path": "%{user} a déplacé l'élément \"%{name}\" de \"%{from}\" vers \"%{to}\"",
          "change_path_by_self": "vous avez déplacé l'élément \"%{name}\" de \"%{from}\" vers \"%{to}\"",
          "create": "%{user} a ajouté l'élément \"%{name}\"",
          "create_by_self": "vous avez ajouté l'élément \"%{name}\"",
          "destroy": "%{user} a supprimé l'élément \"%{name}\" définitivement",
          "destroy_by_self": "Vous avez supprimé l'élément \"%{name} définitivement\"",
          "implant": "%{user} a implanté \"%{name}\"",
          "implant_by_self": "Vous avez implanté \"%{name}\"",
          "remove": "%{user} a retiré \"%{name}\"",
          "remove_by_self": "Vous avez retiré \"%{name}\""
        },
        "harvest": {
          "create": "%{user} a consigné une récolte sur \"%{name}\"",
          "create_by_self": "Vous avez consigné une récolte sur \"%{name}\"",
          "fix": "%{user} a corrigé des données de récolte sur \"%{name}\"",
          "fix_by_self": "Vous avez corrigé des données de récolte sur \"%{name}\""
        },
        "layer": {
          "create": "%{user} a ajouté le calque \"%{name}\"",
          "create_by_self": "Vous avez ajouté le calque \"%{name}\"",
          "destroy": "%{user} a détruit le calque \"%{name}\" et son contenu",
          "destroy_by_self": "Vous avez détruit le calque \"%{name}\" et son contenu",
          "rename": "%{user} a renommé le calque \"%{from}\" en \"%{to}\"",
          "rename_by_self": "Vous avez renommé le calque \"%{from}\" en \"%{to}\""
        },
        "observation": {
          "complete": "%{user} a complété la description de \"%{name}\"",
          "complete_by_self": "Vous avez complété la description de \"%{name}\"",
          "create": "%{user} a observé \"%{name}\"",
          "create_by_self": "Vous avez observé \"%{name}\"",
          "date_fix": "%{user} a changé la date d'observation de \"%{name}\"",
          "date_fix_by_self": "Vous avez changé la date d'observation de \"%{name}\" au %{to}",
          "destroy": "%{user} a supprimé l'observation \"%{name}\" définitivement",
          "destroy_by_self": "Vous avez supprimé l'observation \"%{name}\" définitivement",
          "rename": "%{user} a renommé l'observation \"%{from}\" en \"%{to}\"",
          "rename_by_self": "Vous avez renommé l'observation \"%{from}\" en \"%{to}\""
        },
        "patch": {
          "create": "%{user} a créé la parcelle \"%{name}\"",
          "create_by_self": "Vous avez créé la parcelle \"%{name}\"",
          "destroy": "%{user} a supprimé la parcelle \"%{name}\" définitivement",
          "destroy_by_self": "Vous avez supprimé la parcelle \"%{name}\" définitivement",
          "layer_change": "%{user} a changé de calque pour la parcelle \"%{name}\"",
          "layer_change_by_self": "Vous avez changé de calque pour la parcelle \"%{name}\"",
          "move_or_resize": "%{user} a modifié la géométrie de la parcelle \"%{name}\"",
          "move_or_resize_by_self": "Vous avez modifié la géométrie de la parcelle \"%{name}\"",
          "rename": "%{user} a renommé la parcelle \"%{from}\" en \"%{to}\"",
          "rename_by_self": "Vous avez renommé la parcelle \"%{from}\" en \"%{to}\""
        },
        "path": {
          "create": "%{user} a créé le chemin \"%{name}\"",
          "create_by_self": "Vous avez créé le chemin \"%{name}\"",
          "destroy": "%{user} a supprimé le chemin \"%{name}\" définitivement",
          "destroy_by_self": "Vous avez supprimé le chemin \"%{name}\" définitivement",
          "layer_change": "%{user} a changé de calque pour le chemin \"%{name}\"",
          "layer_change_by_self": "Vous avez changé de calque pour le chemin \"%{name}\"",
          "move_or_resize": "%{user} a modifié la géométrie du chemin \"%{name}\"",
          "move_or_resize_by_self": "Vous avez modifié la géométrie du chemin \"%{name}\"",
          "rename": "%{user} a renommé le chemin \"%{from}\" en \"%{to}\"",
          "rename_by_self": "Vous avez renommé le chemin \"%{from}\" en \"%{to}\""
        },
        "task": {
          "complete": "%{user} a modifié la tâche \"%{name}\" (%{subject})",
          "complete_by_self": "Vous avez modifié la tâche \"%{name}\" (%{subject})",
          "create": "%{user} a ajouté la tâche \"%{name}\" (%{subject}) pour %{assignee}",
          "create_by_self": "Vous avez ajouté la tâche \"%{name}\" (%{subject}) pour %{assignee}",
          "date_change": "%{user} a changé la date de la tâche \"%{name}\" du \"%{from}\" au \"%{to}\"",
          "date_change_by_self": "Vous avez changé la date de la tâche \"%{name}\" du \"%{from}\" au \"%{to}\"",
          "destroy": "%{user} a supprimé la tâche \"%{name}\" (%{subject}) définitivement",
          "destroy_by_self": "Vous avez supprimé la tâche \"%{name} (%{subject})\" définitivement",
          "finish": "%{user} a terminé la tâche \"%{name}\" (%{subject})",
          "finish_by_self": "Vous avez terminé la tâche \"%{name}\" (%{subject})",
          "reassign": "%{user} a réassigné la tâche \"%{name}\" (%{subject}) à \"%{assignee}\"",
          "reassign_by_self": "Vous avez réassigné la tâche \"%{name}\" (%{subject}) à \"%{assignee}\"",
          "rename": "%{user} a renommé la tâche \"%{from}\" en \"%{to}\"",
          "rename_by_self": "Vous avez renommé la tâche \"%{from}\" en \"%{to}\""
        },
        "team_mate": {
          "join": "%{name} a rejoint l'équipe",
          "join_by_self": "Vous avez rejoint l'équipe",
          "leave": "%{name} a quitté l'équipe",
          "leave_by_self": "Vous avez quitté l'équipe"
        }
      },
      "activity": {
        "unknown_action": "Action inconnue (%{subject}, %{action})"
      },
      "admin": {
        "import": {
          "families": "Familles",
          "genera": "Genres",
          "ignore": "Ignorer",
          "import": "Importer",
          "missing_reference": "Cette référence n'a pas (encore) été importée.",
          "new_entry": "Nouvelle entrée",
          "nothing_to_import": "Il n'y a rien à importer ou mettre à jour.",
          "old_entry": "Entrée de la librairie",
          "open_existing": "Ouvrir l'existant",
          "resources": "Ressources",
          "resources_interaction_groups": "Groupes d'interactions",
          "resources_interactions": "Interactions",
          "sync_field": "Synchroniser cette valeur",
          "update": "Mettre à jour"
        }
      },
      "api": {
        "forbidden": "L'accès à cette ressource est interdit.",
        "internal_server_error": "Une erreur interne est survenue",
        "page_not_found": "Page non trouvée : %{url}",
        "unauthorized": "Vous n'avez pas les droits nécessaires pour réaliser cette action",
        "unknown_error": "Une erreur est survenue (%{code})",
        "unprocessable_content": "Impossible d'enregistrer suite à une erreur de formulaire",
        "unreachable_server": "Serveur non disponible"
      },
      "app": {
        "garden": {
          "page": {
            "activities": {
              "no_activities": "Il n'y a pas d'activité dans ce jardin"
            },
            "observations": {
              "no_observations": "Aucune observation n'a été enregistrée dans ce jardin"
            }
          }
        }
      },
      "color_preset": {
        "no_preset_selected": "Aucune pré-selection"
      },
      "color_presets": {
        "concrete": "Béton",
        "forest": "Forêt",
        "grass": "Herbe",
        "hard_path": "Chemin, opaque",
        "important": "Important",
        "light_path": "Chemin, transparent",
        "shadow": "Ombre",
        "water": "Eau"
      },
      "comment": {
        "destroy_warning": "Le commentaire sera vidé et anonymisé, mais pour garder la consistence du fil il ne sera pas supprimé. Si vous souhaitez juste corriger une erreur, vous pouvez toujours l'éditer à la place.",
        "destroy_warning_admin": "Vous allez censurer le commentaire de quelqu'un d'autre ; cette action est irréversible.",
        "destroy_warning_title": "Supprimer un commentaire",
        "failed_to_destroy": "Une erreur a empêché la suppression de ce commentaire.",
        "successfully_destroyed": "Commentaire supprimé"
      },
      "comments": {
        "new_comment": "Écrire un commentaire",
        "new_comment_disclaimer": "Merci de rester respectueux envers les autres",
        "no_comments": "Aucun commentaire",
        "no_comments_anonymous": "Aucun commentaire. Identifiez vous si vous souhaitez commenter."
      },
      "coordination": {
        "empty_patch": "Parcelle vide. Ajoutez-y des éléments...",
        "no_element_to_display": "Il n'y a aucun élément dans vos parcelles. Créez des parcelles ou ajoutez des éléments aux parcelles existantes.",
        "no_patch_to_display": "Vous n'avez aucune parcelle avec des éléments dedans.",
        "show_empty_patches": "Afficher les parcelles vides"
      },
      "crop_rotations": {
        "help": {
          "explanation_1": "Le fait suivre un cycle de rotation permet à la terre de se reposer et de préparer la prochaine étape du cycle avec les nutriments nécessaires pour le prochain groupe.",
          "explanation_2": "Cela permet aussi de plus facilement battre les divers ravageurs en ne leur laissant pas de quoi proliférer d'une année sur l'autre.",
          "explanation_3": "En appliquant les rotations de cultures, un même légume ne se retrouvera au même endroit qu'une fois tous les quatre ans.",
          "explanation_4": "Idéalement, plantez une majorité de légumes d'un même groupe ensemble (avec leur aides si besoin).",
          "header": "Rotation de cultures",
          "introduction": "La rotation de culture est une technique consistant à ne pas faire pousser les mêmes \"groupes\" de plantes deux années de suite au même endroit.",
          "proposition": "Groupes de rotation recommandés au vu de l'année précédente :"
        }
      },
      "element": {
        "destroy_warning": "L'élément sera supprimé ainsi que les données qui lui sont liées :",
        "destroy_warning_complement": "Si vous souhaitez plutôt marquer qu'il n'est plus là, utilisez l'action \"retirer\" ; il sera toujours visible dans l'onglet \"inventaire\".",
        "destroy_warning_lines1": "toutes les tâches liées à l'élément",
        "destroy_warning_lines2": "toutes les observations liées à l'élément",
        "destroy_warning_lines3": "toutes les récoltes liées à l'élément",
        "destroy_warning_title": "Supprimer un élément",
        "failed_to_create": "Impossible de créer cet élément",
        "failed_to_destroy": "Impossible de supprimer cet élément",
        "failed_to_duplicate": "Impossible de dupliquer cet élément",
        "failed_to_update": "Impossible de mettre à jour cet élément",
        "form": {
          "note_help": "Format Markdown supporté.",
          "title": "Modification d'élément"
        },
        "implantation_form": {
          "title": "Implanter"
        },
        "removal_form": {
          "title": "Retirer"
        },
        "successfully_created": "Élément créé avec succès",
        "successfully_destroyed": "Élément supprimé",
        "successfully_duplicated": "Élément dupliqué",
        "successfully_updated": "Élément mis à jour avec succès"
      },
      "elements": {
        "action_buttons": {
          "add_observation": "Nouvelle observation",
          "add_task": "Nouvelle tâche",
          "destroy_element": "Supprimer définitivement",
          "duplicate": "Dupliquer",
          "edit_element": "Modifier",
          "harvests": "Récoltes",
          "implant": "Mettre en place",
          "plantation_date": "Date de mise en place",
          "removal_date": "Date de retrait",
          "remove": "Retirer",
          "show_observations": "Afficher les observations"
        },
        "item_content": {
          "failed_to_implant": "Impossible d'implanter l'élément",
          "failed_to_remove": "Impossible de retirer l'élément",
          "implant_now": "Implanter maintenant",
          "no_implantation_planned": "Implantation non prévue",
          "remove_now": "Enlever maintenant",
          "successfully_implanted": "Élément implanté",
          "successfully_removed": "Élément retiré"
        },
        "last_action": {
          "destroyed_successfully": "Action supprimée",
          "finish": "Terminer"
        },
        "month_graph_legend": {
          "no_planned_removal": "Enlèvement non planifié",
          "not_planned_yet": "Pas encore planifié",
          "planned": "Totalement planifié"
        },
        "observations": {
          "new_observation": "Faire une observation",
          "no_observation": "Aucune observation n'a été faite pour cet élément."
        }
      },
      "error_pages": {
        "404": {
          "gardens": "Jardins",
          "home": "Accueil",
          "image": "Jolie image pour la page 404",
          "title": "La page demandée est introuvable."
        }
      },
      "families": {
        "form": {
          "already_created": "Familles déjà créées :",
          "community_alert": "La création ou modification de familles affectera la communauté. Veuillez être le plus précis possible dans les informations soumises.",
          "source_help": "Lien vers la source de données.",
          "title_edit": "Modification d'une famille",
          "title_new": "Nouvelle famille"
        }
      },
      "garden": {
        "coordination": {
          "back": "Reculer d'un mois",
          "forward": "Avancer d'un mois",
          "group_by": "Grouper par",
          "group_by_patch": "Parcelle",
          "group_by_resource": "Ressource",
          "no_group": "Rien",
          "today": "Aujourd'hui"
        },
        "elements": {
          "actions": {
            "help": {
              "caption": "Actions d'élément",
              "content": "Ces actions vous permettent d'interagir avec l'élément courant. \n\nLa liste ci-dessous peut varier selon le contexte.",
              "duplicate": "Dupliquer l'élément. Dans le cas d'un élément seul, il sera copié sur place.\nLes observations et tâches ne seront pas dupliquées en dehors des tâches d'implantation/retrait.",
              "edit": "Modifier le type d'élément, lui donner un nom et changer son calque",
              "harvests": "Récoltes. Consulter la liste et consigner une quantité récoltée de cet élément.",
              "implant": "Mettre en place. Marquera l'élément comme réellement implanté dans le jardin.",
              "move": "Déplacer l'élément (sur la carte)",
              "new_observation": "Faire une observation (photo, texte)",
              "new_task": "Créer une nouvelle tâche pour cet élément",
              "remove": "Retirer. Marquera l'élément comme retiré du jardin, sans le supprimer.",
              "show_observation": "Afficher les observations",
              "trash": "Détruire. L'élément, son historique et ses observations seront supprimés. À jamais."
            }
          }
        },
        "layers": {
          "new_layer": "Nouveau calque",
          "no_active_layer": "Veuillez sélectionner un calque",
          "no_layers": "Il n'y a aucun calque sur cette carte",
          "panel": {
            "help": {
              "add": "Créer un nouveau calque",
              "caption": "Gestion des calques",
              "content": "Les calques permettent d'organiser les différentes choses que vous ajoutez sur votre carte.\n\nLorsque vous ajouterez des éléments, ils seront créés sur le calque sélectionné.",
              "destroy": "Détruire le calque et tous les chemins présents dessus. \n\nSi un calque a encore des parcelles ou des éléments seuls, il ne pourra pas être supprimé.",
              "edit": "Modifier : Renommer le calque et changer sa visibilité par défaut",
              "reorder": "Réorganiser le calque : maintenez ce bouton cliqué et déplacez le calque dans la liste.",
              "toggle": "Inverse la visibilité du calque temporairement. Pour changer la visibilité par défaut, modifiez-le."
            }
          }
        },
        "loading_map": "Génération de la carte...",
        "loading_map_data": "Chargement des données de la carte",
        "note_form": {
          "markdown_help": "Markdown supporté"
        },
        "patches": {
          "actions": {
            "help": {
              "add_resource": "Ajoute une resource dans la parcelle",
              "caption": "Actions de parcelle",
              "content": "Ces actions vous permettent d'interagir avec la parcelle sélectionnée. \n\nLa liste ci-dessous peut varier suivant le contexte.",
              "destroy": "Supprimer la parcelle. L'intégralité de son contenu et son historique seront détruits. Pour toujours.",
              "edit": "Modifier le nom de la parcelle et son calque",
              "edit_geometry": "Modifier la géométrie (sur la carte)",
              "move": "Déplacer la parcelle (sur la carte)",
              "new_observation": "Faire une observation sur cette parcelle (texte, photo)",
              "new_task": "Créer une tâche pour cette parcelle",
              "rotate": "Faire pivoter la parcelle (sur la carte)",
              "show_observations": "Afficher les observations déjà faites."
            }
          }
        },
        "paths": {
          "popup": {
            "help": {
              "add_task": "Créer une tâche pour ce chemin",
              "caption": "Actions de chemin",
              "destroy": "Supprimer ce chemin. Pour toujours.",
              "display_observations": "Afficher les observations",
              "edit": "Modifier le nom, la couleur, etc... du chemin",
              "edit_geometry": "Modifier la géométrie (sur la carte)",
              "move": "Déplacer le chemin (sur la carte)",
              "new_observation": "Faire une observation sur ce chemin (texte, photo)",
              "rotate": "Faire pivoter le chemin (sur la carte)"
            }
          }
        },
        "right_panel": {
          "layers": {
            "title": "Calques"
          }
        },
        "show_maps_list": "Afficher les cartes",
        "toolbar": {
          "help": {
            "add": {
              "caption": "Ajouter des éléments \"seuls\" et des parcelles",
              "circle": "Créer une parcelle circulaire",
              "content": "Les éléments \"seuls\" sont parfait pour représenter des abres, buissons, etc...\n\nLes parcelles servent plutôt à représenter des zones de culture avec de multiples plants à l'interieur.\n\nPour dessiner une parcelle :\n- cliquez sur la forme que vous souhaitez\n- choisissez la ressource à ajouter\n- dessinez, point après point, la géométrie de la parcelle. Un double-clic en cours de route fermera automatiquement la géométrie.\n\nSi vous avez des parcelles virtuelles, vous pouvez les intégrer à la carte :\n- cliquez sur le bouton \"Ajouter une parcelle virtuelle\",\n- choisissez la parcelle et son type de forme\n- validez\n- dessinez la parcelle sur la carte",
              "point": "Créer un élément \"seul\"",
              "polygon": "Créer une parcelle polygonale.",
              "virtual_patch": "Intégrer une parcelle virtuelle"
            },
            "draw": {
              "caption": "Dessiner des chemins",
              "circle": "Dessiner un cercle",
              "content": "Les chemins (au sens \"dessin\"), servent à représenter des zones géométriques de votre jardin (clôtures, mares, chemins, ...)\n\nIls ne contiennent pas de plantes et ne sont affichés que sur la carte.\n\nPour dessiner un chemin : \n- cliquez sur la forme que vous souhaitez\n- choisissez les couleurs et type de lignes et validez votre selection\n- dessinez ensuite, point après point, la géométrie de la parcelle. Un double-clic en cours de route fermera automatiquement la géométrie.",
              "line": "Dessiner des segments de ligne",
              "polygon": "Dessiner un polygone"
            }
          }
        }
      },
      "gardens": {
        "home": {
          "library": "Bibliothèque",
          "library_description": "Trouvez la bonne ressource à ajouter à votre jardin",
          "soil_analysis": "Analyse de sol",
          "soil_analysis_description": "Déterminez la composition de votre sol avec un prélèvement et un bocal",
          "tools": "Outils"
        }
      },
      "genera": {
        "form": {
          "already_created": "Genres déjà créés :",
          "community_alert": "La création ou modification de genres affectera la communauté. Veuillez être le plus précis possible dans les informations soumises.",
          "source_help": "Lien vers la source de données.",
          "title_edit": "Modification d'un genre",
          "title_new": "Nouveau genre"
        }
      },
      "generic": {
        "activity": "Activité",
        "displaying_amount_on_total": "Affichage de %{amount}/%{total}",
        "empty": "vide",
        "errors": {
          "page_not_found": "Erreur 404"
        },
        "failed_to_save": "Une erreur est survenue lors de l'enregistrement",
        "harvests": "Récoltes",
        "impossible_action": "Action impossible",
        "load_error": "Une erreur est survenue lors du chargement des données nécessaires à l'application.",
        "loading_data_error": "Une erreur est survenue lors de la récupération des données.",
        "more": "Plus...",
        "move": "Déplacer",
        "next": "Suivant",
        "observations": "Observations",
        "others": "Autres",
        "reload": "Recharger",
        "retry": "Réessayer",
        "rotate": "Tourner",
        "send": "Envoyer",
        "show_details": "Afficher les détails",
        "successfully_saved": "Enregistrement effectué",
        "tasks": "Tâches",
        "total": "Total",
        "transform": "Modifier la géométrie",
        "you": "vous"
      },
      "harvest": {
        "destroy_warning": "L'entrée sera supprimée et c'est irréversible.",
        "destroy_warning_title": "Supprimer une entrée de récolte",
        "failed_to_destroy": "Une erreur s'est produite lors de la suppression",
        "successfully_destroyed": "Entrée supprimée avec succès"
      },
      "harvests": {
        "element_harvests": {
          "already_harvested": "Déjà récolté",
          "new_harvest": "Récolter",
          "no_record_yet": "Cet élément n'a jamais été récolté"
        },
        "form": {
          "title": "Récolter"
        },
        "no_harvests": "Aucune donnée de récolte n'a été enregistrée. Vous pouvez saisir vos\ndonnées de récolte sur les éléments de la carte, de l'inventaire ou de\nla coordination.\n"
      },
      "inventory": {
        "crop_rotation_groups": "Rotation de cultures",
        "no_element_to_display": "Aucun élément à afficher",
        "no_patch_to_display": "Aucune parcelle à afficher",
        "panel": {
          "elements": "Élements",
          "patches": "Parcelles"
        },
        "please_select_an_entry": "Sélectionnez une entrée dans la liste",
        "removed_elements": "Élements retirés"
      },
      "layer": {
        "destroy_warning": "Le calque est vide et peut être supprimé en toute sécurité.",
        "destroy_warning_title": "Supprimer un calque"
      },
      "layers": {
        "background_layer": "Image de fond",
        "failed_to_destroy": "Une erreur s'est produite lors de la suppression",
        "form": {
          "failed_to_create": "Une erreur s'est produite lors de la création du calque",
          "successfully_created": "Calque enregistré",
          "title_edit": "Modification d'un calque",
          "title_new": "Nouveau calque"
        },
        "move": "Déplacer pour réorganiser",
        "patches_and_paths_remaining": "Il reste %{patches_count} parcelle(s) et %{paths_count} chemin(s) sur ce calque.\nVeuillez les déplacer ou les supprimer pour continuer.\n",
        "patches_remaining": "Il reste %{count} parcelle(s) sur ce calque.\nVeuillez les déplacer ou les supprimer pour continuer.\n",
        "paths_remaining": "Il reste %{count} chemin(s) sur ce calque.\nVeuillez les déplacer ou les supprimer pour continuer.\n",
        "successfully_destroyed": "Calque supprimé",
        "title": "Calques",
        "toggle": "Changer la visibilité"
      },
      "layout": {
        "switch_to_dark_theme": "Appliquer le thème sombre",
        "switch_to_light_theme": "Appliquer le thème clair"
      },
      "layouts": {
        "garden": {
          "info": {
            "add_map_observation": "Nouvelle observation de carte",
            "add_map_task": "Nouvelle tâche de carte",
            "add_patch_observation": "Nouvelle observation de parcelle",
            "add_patch_task": "Nouvelle tâche de parcelle",
            "add_resource": "Ajouter une ressource"
          },
          "integrate_virtual_patch": "Intégrer une parcelle virtuelle",
          "main_menu": {
            "activity": "Activité",
            "back_to": "Retour à \"%{name}\"",
            "coordination": "Coordination",
            "edit_map": "Édition de carte",
            "harvests": "Récoltes",
            "home": "Cartes",
            "inventory": "Inventaire",
            "library": "Bibliothèque",
            "map": "Carte",
            "new_map": "Nouvelle carte",
            "notifications": "Notifications",
            "resource_interactions_groups": "Groupes d'interactions",
            "soil_analysis": "Analyse de sol",
            "tasks": "Tâches",
            "team": "Équipe",
            "timeline": "Timeline"
          },
          "map_not_found": "Désolé, la carte n'a pas été trouvée.",
          "path": "Chemin",
          "resources": "Resources",
          "show_layers": "Afficher les calques",
          "side_panel": {
            "button_add_virtual_patch": "Intégrer une parcelle virtuelle",
            "button_draw_circle": "Faire un cercle",
            "button_draw_line": "Ajouter une ligne",
            "button_draw_point": "Ajouter un point",
            "button_draw_polygon": "Ajouter un polygone"
          },
          "toolbar": {
            "activities": "Activité",
            "add_patch": "Parcelle",
            "coordination": "Coordination",
            "draw_path": "Chemin",
            "drawing_lines_help": "Pour terminer la forme, double-cliquez.",
            "harvests": "Récoltes",
            "library": "Bibliothèque",
            "map": "Carte",
            "resource_overview": "Inventaire",
            "soil_analysis": "Analyse de sol",
            "stop": "Terminer",
            "team": "Équipe",
            "timeline": "Timeline",
            "todo": "Tâches"
          }
        },
        "library": {
          "family": "Famille",
          "genus": "Genre",
          "new_family": "Famille",
          "new_genus": "Genre",
          "new_resource": "Ressource",
          "new_resource_interactions_group": "Groupe d'interactions",
          "resource": "Ressource",
          "resource_interactions_groups": "Groupes d'interactions"
        },
        "shared_maps": {
          "map_observations": "Observations"
        }
      },
      "library": {
        "filters": {
          "crop_rotations": "Rotations de cultures",
          "harvesting_months": "Récolte",
          "reset": "Supprimer les filtres",
          "sheltered_sowing_months": "Semis sous abris",
          "soil_sowing_months": "Semis en pleine terre"
        },
        "index": {
          "new_family": "Ajouter une famille",
          "new_genus": "Ajouter un genre",
          "new_resource": "Ajouter une ressource",
          "no_family_to_display": "Aucune famille à afficher",
          "no_genus_to_display": "Aucun genre à afficher",
          "no_resource_in_family": "Cette famille n'a pas encore de ressources associées.",
          "no_resource_in_genus": "Ce genre n'a pas encore de ressources associées.",
          "no_resource_to_display": "Aucune ressource ne correspond à ces critères."
        },
        "nothing_selected": {
          "image_alt": "Image représentant une bibliothèque",
          "line1": "Ceci est la base de connaissance partagée entre les membres de cette instance.",
          "line2": "C'est ici que vous pouvez consulter, créer et modifier les différentes ressources à ajouter dans vos jardins.",
          "title": "Bibliothèque partagée"
        }
      },
      "loaders": {
        "loading_account": "Compte utilisateur",
        "loading_families": "Familles de ressources",
        "loading_genera": "Genres de ressources",
        "loading_maps": "Cartes",
        "loading_notifications": "Notifications",
        "loading_resource_interactions": "Interactions inter-ressources",
        "loading_resource_interactions_groups": "Groupes d'interactions inter-ressources",
        "loading_resources": "Ressources"
      },
      "map": {
        "destroy_confirm": "La carte et toutes ses données seront supprimées définitivement.",
        "destroy_confirm_title": "Supprimer une carte",
        "failed_to_destroy": "La carte n'a pas pu être supprimée",
        "index": {
          "display_shared_version": "Afficher la version publique",
          "favorite_help": "Une carte épinglée s'ouvrira automatiquement la prochaine fois que vous ouvrirez l'app.",
          "no_map_available": "Vous n'avez aucune carte pour le moment. Ce serait une bonne idée d'en créer une."
        },
        "note": {
          "empty": "La note est vide !"
        },
        "owner": "propriétaire",
        "successfully_destroyed": "Carte supprimée"
      },
      "map_controls": {
        "help": {
          "pan": "Déplacer la vue",
          "pan_html": "<kbd>clic</kbd> et bouger la souris",
          "rotate": "Rotation",
          "rotate_html": "<kbd>alt</kbd> + <kbd>maj</kbd> + <kbd>clic</kbd> et bouger la souris",
          "zoom": "Zoom",
          "zoom_html": "<kbd>molette</kbd> de la souris",
          "zoom_on_area": "Zoom sur une zone",
          "zoom_on_area_html": "<kbd>maj</kbd> + <kbd>clic</kbd>; glisser pour sélectionner la zone et relâcher"
        },
        "hide_advanced_controls": "Masquer les contrôles supplémentaires",
        "pan_down": "Déplacer vers le bas",
        "pan_left": "Déplacer à gauche",
        "pan_right": "Déplacer à droite",
        "pan_up": "Déplacer vers le haut",
        "reset_view": "Réinitialiser la vue",
        "rotate_clockwise": "Rotation horaire",
        "rotate_counter_clockwise": "Rotation anti-horaire",
        "show_more_controls": "Afficher plus de contrôles",
        "zoom_in": "Zoomer",
        "zoom_out": "Dézoomer"
      },
      "maps": {
        "edit": {
          "title": "Modification d'une carte"
        },
        "form": {
          "center_changed_note": "Le centre a été modifié",
          "custom_background_color": "Couleur de fond personnalisée",
          "extent_change_warning": "Lorsque vous changez d'échelle, vous devez re-définir le centre de la carte.",
          "extent_changed_note": "L'échelle a été modifié. Vous devriez redéfinir le centre du jardin.",
          "groups": {
            "background": "Fond de carte",
            "center_definition": "Définition du centre",
            "general": "General",
            "map_scaling": "Mise à l'échelle"
          },
          "name_placeholder": "Mon jardin",
          "osm_map": "Carte OSM",
          "pick_color": "Choisissez une couleur",
          "picture_map": "Utilisez une image",
          "publicly_available_help": "Une carte publique peut être partagée pour consultation. Toutes les données (notes, photos, ...) seront visibles.",
          "save_this_map": "Enregistrez cette carte",
          "scale_help": "Définition de l'échelle de la carte:",
          "scale_help_step_1": "Entrez une longueur que vous connaissez, en mètres, dans le champ ci-dessous (ex. : mur, parcelle,...)",
          "scale_help_step_2": "Tracez une ligne représentant cette longueur sur la carte (clic pour commencer ; clic pour finir)",
          "scale_map": "Mise à l'échelle",
          "scale_reference": "Référence d'échelle",
          "select_center": "Changer le centre",
          "select_center_note": "Veuillez cliquer sur le point représentant le centre de votre jardin",
          "select_picture": "Sélectionnez une image"
        },
        "index": {
          "new_map": "Nouvelle carte",
          "title": "Vos cartes"
        },
        "new": {
          "title": "Nouvelle carte"
        },
        "other_maps": "Autres cartes"
      },
      "months_graphs": {
        "empty_list": "Aucun élément à afficher"
      },
      "notifications": {
        "action": {
          "accept": "Accepter",
          "archive": "Archiver",
          "delete": "Supprimer",
          "refuse": "Refuser"
        },
        "archive_all": "Tout archiver",
        "delete_all_archived": "Supprimer les archives",
        "list": {
          "title": "Notifications"
        },
        "messages": {
          "a_task": "une tâche",
          "an_observation": "une observation",
          "new_comment": "%{username} a laissé un message sur %{subject_link}",
          "team_mate_accept": "%{username} a rejoint votre équipe sur %{map}",
          "team_mate_invitation": "%{username} vous a invité sur sa carte %{map}",
          "team_mate_leave": "%{username} a quitté la carte %{map}",
          "team_mate_refuse": "%{username} a refusé votre invitation sur %{map}",
          "team_mate_remove": "%{username} vous a retiré de sa carte %{map}",
          "unhandled_notification_type": "Type de notification non supporté"
        },
        "no_notification": "Vous n'avez aucune notification"
      },
      "observation": {
        "destroy_confirmation": "Cette action est irréversible",
        "destroy_confirmation_title": "Supprimer une observation",
        "edit": {
          "cannot_change_pictures_yet": "L'édition de la liste d'images n'est pas encore possible"
        },
        "failed_to_create": "Impossible d'enregistrer l'observation",
        "failed_to_destroy": "Impossible de supprimer l'observation",
        "has_content": "Contient du texte",
        "has_pictures": "Contient des images",
        "successfully_created": "Observation sauvegardée",
        "successfully_destroyed": "Observation supprimée avec succès"
      },
      "observations": {
        "comments": "Commentaires",
        "form": {
          "accepted_mimes": "Fichiers acceptés: %{types}",
          "date": "Date",
          "edit_title": "Modification d'observation",
          "new_title": "Nouvelle observation"
        },
        "list": {
          "title": "Observations"
        },
        "month_and_year": "{month} {year}",
        "one_observation": "Observation"
      },
      "patch": {
        "current_rotation_groups": "Groupe(s) de rotation de culture actuel(s)",
        "destroy_title": "Supprimer une parcelle",
        "destroy_warning": "La parcelle et tout ce qu'elle contient sera détruit :",
        "destroy_warning_lines1": "tous ses éléments, leurs tâches, observations et récoltes associées",
        "destroy_warning_lines2": "toutes les tâches associées à cette parcelle",
        "destroy_warning_lines3": "toutes les observations associées à cette parcelle",
        "failed_to_add_virtual_patch": "Impossible d'ajouter la parcelle virtuelle",
        "failed_to_create": "Impossible de créer la parcelle",
        "failed_to_destroy": "Impossible de supprimer la parcelle",
        "failed_to_update": "Impossible de mettre la parcelle à jour",
        "form": {
          "make_virtual": "Rendre virtuel",
          "make_virtual_help": "Rendre cette parcelle \"virtuelle\" la masquera de la carte. Vous pourrez la réintégrer plus tard mais devrez la re-dessiner."
        },
        "next_rotation_groups": "Groupe(s) de rotation recommandé(s)",
        "no_element_in_this_patch": "Il n'y a (plus) rien dans cette parcelle",
        "successfully_added_virtual_patch": "Parcelle virtuelle ajoutée avec succès",
        "successfully_created": "Parcelle créée",
        "successfully_destroyed": "Parcelle supprimée",
        "successfully_updated": "Parcelle mise à jour"
      },
      "patches": {
        "form": {
          "title": {
            "create_virtual": "Nouvelle parcelle virtuelle",
            "update": "Modification de parcelle"
          }
        },
        "help": {
          "virtual_patches": "Les parcelles virtuelles ne sont pas visibles sur la carte. Elles sont pratiques, par exemple, pour prévoir\ndes associations ou gérer ses semis avant de les intégrer aux parcelles existantes.\n"
        },
        "index": {
          "patch_selection": "Sélection d'une parcelle",
          "resource_selection": "Sélection d'une ressource"
        },
        "new_virtual_patch": "Nouvelle parcelle virtuelle",
        "virtual_patch_selector": {
          "circle": "Parcelle circulaire",
          "no_virtual_patches": "Aucune parcelle virtuelle",
          "polygon": "Parcelle polygonale",
          "select_patch": "Parcelle",
          "select_shape": "Forme",
          "submit": "Dessiner la parcelle"
        }
      },
      "path": {
        "default_name": "Un chemin",
        "destroy_warning": "Le chemin et les données associées seront détruits :",
        "destroy_warning_lines1": "toutes les tâches associées",
        "destroy_warning_lines2": "toutes les observations associées",
        "destroy_warning_title": "Supprimer un chemin",
        "failed_to_create": "Impossible de créer le dessin",
        "failed_to_destroy": "Impossible de supprimer le dessin",
        "failed_to_update": "Impossible de mettre le dessin à jour",
        "inputs": {
          "line_style": "Style de ligne",
          "preset": "Présélection",
          "preview": "Aperçu"
        },
        "successfully_created": "Dessin créée",
        "successfully_destroyed": "Dessin supprimée",
        "successfully_updated": "Dessin mis à jour"
      },
      "paths": {
        "form": {
          "title": "Modification de chemin"
        }
      },
      "resourceInteractionsGroups": {
        "index": {
          "no_selected_group": "Aucun groupe attribué à cette ressource"
        }
      },
      "resource_interaction": {
        "form": {
          "interaction_pair_exists": "Une interaction entre ces deux groupes existe déjà.",
          "nature_help": "Aide pour choisir la bonne nature",
          "successfully_saved": "Interaction enregistrée avec succès",
          "title_edit": "Modification d'une interaction inter-groupes",
          "title_new": "Nouvelle interaction inter-groupes"
        },
        "help_table": {
          "more_info_link_html": "Plus d'information sur {0}.",
          "wikipedia_link": "l'article Wikipedia",
          "wikipedia_url": "https://fr.wikipedia.org/wiki/Interaction_biologique"
        },
        "list": {
          "negative_interactions": "Négative",
          "neutral_interactions": "Neutre",
          "new_resource_interaction": "Nouvelle interaction",
          "no_group_specified": "Aucun groupe spécifié",
          "no_known_interactions": "Aucune interaction renseignée",
          "positive_interactions": "Positive"
        }
      },
      "resource_interactions": {
        "list_entry": {
          "interaction_type": "Type :"
        }
      },
      "resource_interactions_group": {
        "form": {
          "community_alert": "La création ou modification de groupes d'interactions affectera la communauté. Veuillez être le plus précis possible dans les informations soumises.",
          "title_edit": "Modification d'un groupe d'interactions",
          "title_new": "Nouveau groupe d'interactions"
        },
        "item": {
          "interactions": "Interactions",
          "no_resource": "Aucune ressource n'est attribuée à ce groupe",
          "resources": "Ressources"
        }
      },
      "resource_note": {
        "destroy_warning": "Cette action est irreversible",
        "destroy_warning_title": "Supprimer une note",
        "failed_to_destroy": "Impossible de supprimer la note",
        "form": {
          "missing_resource_id": "Aucune resource sélectionnée",
          "title_edit": "Modifier une note",
          "title_new": "Nouvelle note",
          "visible_help": "En cochant cette option, votre note sera visible par la communauté."
        },
        "successfully_destroyed": "Note supprimée"
      },
      "resources": {
        "description_area": {
          "children": "Variantes",
          "description_missing": "Cette ressource n'a pas de description. Modifiez-la pour la compléter !",
          "harvesting_months": "Récolte",
          "interactions": "Interactions",
          "interactions_for": "Interactions avec le groupe \"%{group}\"",
          "new_note": "Nouvelle note",
          "no_sources": "Aucune source d'information n'a été spécifiée",
          "no_tags": "Aucun tag n'est associé",
          "no_user_note": "Aucune note n'a été soumise",
          "sheltered_sowing_months": "Semis sous abris",
          "soil_sowing_months": "Semis en pleine terre",
          "sow_harvest": "Semis/récolte",
          "user_notes": "Notes",
          "user_notes_loading_error": "Impossible de charger les notes"
        },
        "form": {
          "already_created": "Ressources déjà créées :",
          "community_alert": "La création ou modification de ressources affectera la communauté. Veuillez être le plus précis possible dans les informations soumises.",
          "latin_name_help": "Nom latin de l'espèce/cultivar. Pour une entrée générique, le genre seul peut aussi être utilisé",
          "parent_help": "Sélectionnez une resource parente si celle-ci en est une variante.",
          "resource_interactions_group_id_help": "Choisissez un groupe existant pour définir les interactions avec les autres ressources",
          "sources_help": "Liens vers des sources d'information. Une URL par ligne.",
          "tags_help": "Liste de tags ; il est possible de créer des tags composés en séparant les éléments par \"::\"",
          "title_edit": "Modification d'une resource",
          "title_new": "Nouvelle ressource"
        },
        "selector": {
          "empty": "Aucune ressource ne correspond aux filtres",
          "no_resource": "Aucune ressource",
          "no_resource_text": "Créée une parcelle vide",
          "recommended_rotation_group": "Groupes de rotation de cultures recommandés",
          "same_rotation_group": "Groupes de rotation déjà ajoutés"
        }
      },
      "shared_garden": {
        "legend": {
          "empty": "Parcelle vide",
          "multiple": "Multiple ressources",
          "title": "Légende"
        }
      },
      "soil_analysis": {
        "links": {
          "clay": {
            "name": "Argile",
            "url": "https://fr.wikipedia.org/wiki/Argile"
          },
          "sand": {
            "name": "Sable",
            "url": "https://fr.wikipedia.org/wiki/Sable"
          },
          "silt": {
            "name": "Limon",
            "url": "https://fr.wikipedia.org/wiki/Limon_(roche)"
          }
        },
        "reading_results": "Lecture des résultats",
        "reading_results_content": {
          "p1": "Une fois les bocaux décantés, devraient apparaître des strates différentes. Du\nbas vers le haut : {sand}, {silt} et {clay}.\n",
          "p2": "Pour lire ces résultats :",
          "p3": "Vous avez votre type de sol, trouvez ce que vous pouvez planter dessus !",
          "p4": "Note: certaines terres ne contiennent que très peu ou pas du tout de certains\ndes éléments précédents.\n",
          "step1": "Mesurez les différentes couches",
          "step2": "Reportez-les dans le formulaire (pas d'unité à préciser tant que vous utilisez la même partout)",
          "step3": "Relevez la zone ciblée sur l'image"
        },
        "setup": "Préparation",
        "setup_content": {
          "p1": "Une méthode simple pour connaitre le {type} de votre terre, consiste à\nfaire un ou plusieur prélèvements (suivant la taille du jardin).\n",
          "p2": "Pour chaque endroit :",
          "step1": "Prélevez de la terre",
          "step2": "Placez-la dans un bocal avec beaucoup d'eau (le même volume est bien)",
          "step3": "Mélangez bien la mixture, que les éléments se séparent les un des autres",
          "step4": "Laissez décanter quelques jours (quand l'eau n'est plus trouble, c'est bon !)",
          "step5": "Lisez les résultats.",
          "type": "type"
        }
      },
      "stroke_style_presets": {
        "dashed": "Ligne brisée",
        "dashed2": "Ligne brisée #2",
        "dashed3": "Ligne brisée #3",
        "default": "Ligne",
        "dotted": "Pointillés",
        "line_style": "Style de ligne",
        "long_dashes": "Longs tirets",
        "long_dashes2": "Longs tirets #2",
        "long_dashes3": "Longs tirets #3"
      },
      "task": {
        "actions": {
          "implant": "Mettre en place",
          "remove": "Retirer"
        },
        "destroy_warning": "Vous vous apprêtez à supprimer une tâche. Cette suppression n'a pas d'impact particulier et ce message est uniquement là pour vous laisser la possibilité d'annuler.",
        "destroy_warning_title": "Supprimer une tâche",
        "done_early_by_days": "Réalisée en avance de %{days}j.",
        "done_late_by_days": "Réalisée en retard de %{days}j.",
        "failed_to_create": "Impossible d'enregistrer la tâche",
        "successfully_created": "Tâche enregistrée",
        "undo_action_notice": "Changer le status de cette tâche n'aura pas d'impact sur l'élément associé (ex. pour une tâche \"d'implantation\":\nl'élément implanté le gardera sa date d'implantation actuelle).\n",
        "undo_action_title": "Changer le status de la tâche",
        "unknown_action": "Action inconnue"
      },
      "tasks": {
        "form": {
          "mark_as_done": "Marquer comme terminée",
          "recent_tasks": "Tâches récentes",
          "title": "Nouvelle tâche"
        },
        "one_task": "Tâche",
        "show_done": "Afficher terminées",
        "status": "Status"
      },
      "team_mates": {
        "complete_team": "Compléter l'équipe",
        "leave": "Quitter",
        "pending_invitation": "Invitation envoyée",
        "remove": "Retirer de l'équipe",
        "search_by_email": "Rechercher par adresse de courriel",
        "search_by_username": "Rechercher par nom d'utilisateur",
        "successfully_accepted": "Vous avez rejoint l'équipe",
        "successfully_invited": "%{name} a été invité.",
        "successfully_left": "Vous avez quitté l'équipe",
        "successfully_refused": "Vous avez refusé de rejoindre l'équipe",
        "team_mates": "Équipiers"
      },
      "timeline": {
        "display_tasks": "Afficher les tâches",
        "empty_entry": "Aucune information supplémentaire"
      },
      "todos": {
        "index": {
          "no_tasks": "Vous n'avez rien de prévu."
        },
        "task": {
          "element_in_patch": "%{elementName} (dans %{patchName})"
        }
      },
      "unit": {
        "centilitre": "Centilitre | Centilitres",
        "cubic_meter": "Mètre cube | Mètres cube",
        "gram": "Gramme | Grammes",
        "kilogram": "Kilogramme | Kilogrammes",
        "litre": "Litre | Litres",
        "millilitre": "Millilitre | Millilitres",
        "piece": "Pièce | Pièces",
        "ton": "Tonne | Tonnes"
      },
      "user": {
        "invite_on_instance": "Inviter sur Garden Party",
        "pending_activation": "Compte inactif",
        "successfully_invited": "%{name} a bien été invité sur l'instance."
      },
      "users": {
        "invite_email": "%{email} n'est pas encore membre. Vous pouvez tout de même l'inviter en spécifiant un nom d'utilisateur changeable par la suite.",
        "search": {
          "hide": "Masquer les résultats",
          "invite": "Inviter",
          "no-results": "Personne n'a été trouvé avec ces critères",
          "username_help": "Il faut au moins %{amount} caractères pour que la recherche aboutisse"
        }
      },
      "widgets": {
        "soil_analyzer": {
          "acronym": {
            "clayey": "A",
            "clayey_sandy": "AS",
            "clayey_silty": "AL",
            "fine-silty": "Lf",
            "fine-silty_clayey": "LfA",
            "sandy": "S",
            "sandy_silty": "SL",
            "silty": "L",
            "silty_clayey": "LA",
            "silty_clayey_sandy": "LAS",
            "silty_fine-clayey": "LAf",
            "silty_sandy": "LS",
            "very-fine-silty": "Ltf"
          },
          "clay": "Argile",
          "legend": {
            "clayey": "Argileux",
            "clayey_sandy": "Argilo-sableux",
            "clayey_silty": "Argilo-limoneux",
            "fine-silty": "Limoneux fin",
            "fine-silty_clayey": "Limoneux fin argileux",
            "sandy": "Sableux",
            "sandy_silty": "Sablo-limoneux",
            "silty": "Limoneux",
            "silty_clayey": "Limono-argileux",
            "silty_clayey_sandy": "Limono-argilo-sableux",
            "silty_fine-clayey": "Limono-argileux fin",
            "silty_sandy": "Limono-sableux",
            "texture": {
              "clayey": "Texture argileuse",
              "equilibrate": "Texture équilibrée",
              "sandy": "Texture sableuse",
              "silty": "Texture limoneuse"
            },
            "very-fine-silty": "Limoneux tres fin"
          },
          "sand": "Sable",
          "silt": "Limon"
        }
      }
    },
    "js_dates": {
      "compact": {
        "day": "numeric",
        "hour": "numeric",
        "minute": "numeric",
        "month": "numeric",
        "year": "numeric"
      },
      "date": {
        "day": "numeric",
        "month": "short",
        "year": "numeric"
      },
      "date_and_day": {
        "day": "numeric",
        "month": "short",
        "weekday": "long"
      },
      "day_name": {
        "weekday": "short"
      },
      "medium": {
        "day": "numeric",
        "hour": "numeric",
        "minute": "numeric",
        "month": "short",
        "year": "numeric"
      }
    },
    "models": {
      "element": {
        "duplicate_name_suffix": "%{name} - copie",
        "name": {
          "element_in_patch": "%{resource_name} (dans %{patch_name})",
          "point_element": "%{element_name} (%{resource_name})"
        }
      },
      "layer": {
        "default_name": "Calque par défaut"
      },
      "resource_interaction": {
        "natures": {
          "amensalism_help": "Le sujet a un impact négatif sur la cible, mais n'en retire rien",
          "commensalism_help": "Le sujet est impacté positivement par la cible, sans lui nuire",
          "competition_help": "Le sujet et la cible ont un impact négatif l'un sur l'autre",
          "mutualism_help": "Les deux ressources sont bénéfiques l'une envers l'autre",
          "neutralism_help": "Aucun impact n'a été observé, mais c'est connu",
          "parasitism_help": "Le sujet est impacté positivement par la cible, mais lui nuit",
          "unspecified_negative_help": "On sait seulement que ça ne fonctionne pas très bien pour le sujet",
          "unspecified_positive_help": "On sait seulement que c'est une bonne interaction pour le sujet"
        }
      }
    },
    "rui": {
      "confirm_dialog": {
        "are_you_sure": "Êtes vous sûr(e) ?"
      },
      "form_errors": {
        "has_errors": "Veuillez vérifier le formulaire sur les points suivants :"
      },
      "generic": {
        "cancel": "Annuler",
        "close": "Fermer",
        "definition": "{term} :",
        "ok": "OK",
        "save": "Enregistrer"
      },
      "help_button": {
        "help": "Aide"
      },
      "image_viewer": {
        "a_picture": "Une image",
        "a_thumbnail": "Une miniature",
        "next": "Suivant",
        "previous": "Précédent"
      },
      "input": {
        "clear": "Effacer"
      },
      "search": {
        "placeholder": "Saisissez quelque chose à chercher...",
        "search": "Rechercher"
      }
    }
  }
}